
const columnList: Array<column> = [
    {
        prop: "ordersn",
        label: "跟进类型",
        width: 66,
    },
    {
        prop: "serve_time",
        label: "内容",
        width: 66,
    },
    {
        prop: "nickname",
        label: "时间",
        width: 66,
    },
    {
        prop: "orderstatus",
        label: "跟进人",
        width: 66,
    },
    {
        prop: "settlement_time",
        label: "客户",
        width: 66,
    },
    {
        prop: "progress",
        label: "手机",
        width: 66,
    },
];
import { serveRecord } from "@/api/shenghuiHttp";
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import { column } from "@/assets/types/common";
import { useRoute } from "vue-router";
export default defineComponent({
    name: "Follow",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["到期提醒"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            loading = ref(true),
            headClass = inject("headClass"),
            route = useRoute(),
            dialogFormVisible = ref(false),
            getTableData = (): void => {
                loading.value = true;
                serveRecord({
                    page: currentPage.value,
                    page_size: pageSize.value,
                    car_id: route.query.id,
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            },
            btnClick = () => {};
            let form  = ref({
                    cname:'',
                type:null,
                    content:''
            }),
            formRef = ref(null),
            onSubmit = () => {
                (formRef.value as any).validate((valid: boolean) =>{
                    if(valid){

                    }
                })
            }
        onMounted(() => {
            getTableData();
        });

        return {
            columnList,
            tableData,
            loading,
            headClass,
            total,
            pageSize,
            currentPage,
            dialogFormVisible,
            form,
            formRef,
            onSubmit
        };
    },
});
